/* Knobs.co — Trade application handler v3 (Worker-backed, truthful success).
   ─────────────────────────────────────────────────────────────────
   Submits the application as JSON to the Cloudflare Worker endpoint
   (form data-endpoint attr), which creates/updates the Shopify customer
   (tag trade-applicant + note + TradePro consent) via the Admin API and
   returns ok ONLY after Shopify confirms the write.

   Success panel is shown ONLY on a confirmed ok:true — never on faith.
   On any failure the applicant sees an error with a trade@knobs.co
   fallback, so a lost submission is never silently swallowed.

   On confirmed success we also fire the Klaviyo identify + "Trade
   Application Received" event (same names as v1/v2) so segments and
   flows stay unified.
*/
(function () {
  'use strict';

  var root = document.getElementById('knobs-trade-app');
  if (!root) return;
  var form = root.querySelector('#ta-form');
  var successEl = root.querySelector('[data-trade-success]');
  var errEl = root.querySelector('[data-trade-error]');
  var eventName = root.getAttribute('data-klaviyo-event') || 'Trade Application Received';
  if (!form) return;
  var endpoint = form.getAttribute('data-endpoint');

  function klaviyoPush(tuple) {
    try { window.klaviyo = window.klaviyo || []; window.klaviyo.push(tuple); return true; }
    catch (e) { return false; }
  }
  function val(name) {
    var el = form.elements[name];
    return el ? (el.value || '').trim() : '';
  }
  function readFirstTouch() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)knobs_ft=([^;]+)/);
      return m ? JSON.parse(decodeURIComponent(m[1])) : {};
    } catch (e) { return {}; }
  }
  function showError(msg) {
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.classList.add('is-visible');
  }
  function clearError() {
    if (!errEl) return;
    errEl.textContent = '';
    errEl.classList.remove('is-visible');
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var FALLBACK = ' Please email trade@knobs.co and we’ll set you up directly.';

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearError();

    var d = {
      first: val('first_name'),
      last: val('last_name'),
      email: val('email'),
      phone: val('phone'),
      company: val('company'),
      website: val('website'),
      business_type: val('business_type'),
      annual_orders: val('annual_orders'),
      project_types: val('project_types'),
      message: val('message'),
      bill_address1: val('bill_address1'),
      bill_address2: val('bill_address2'),
      bill_city: val('bill_city'),
      bill_state: val('bill_state'),
      bill_zip: val('bill_zip'),
      bill_country: val('bill_country'),
      fax: val('fax')
    };

    /* first-touch origin (sitewide knobs_ft cookie) + current-page fallback */
    var ft = readFirstTouch();
    var qp = new URLSearchParams(location.search);
    d.ft_source = ft.s || qp.get('utm_source') || '';
    d.ft_medium = ft.m || qp.get('utm_medium') || '';
    d.ft_campaign = ft.c || qp.get('utm_campaign') || '';
    d.ft_referrer = ft.ref || document.referrer || '';
    d.ft_landing = ft.lp || location.pathname || '';
    d.ft_ts = ft.ts || '';

    if (!d.first || !d.last || !d.email || !d.company || !d.business_type) {
      return showError('Please fill in the required fields (name, email, company, business type).');
    }
    if (!d.bill_address1 || !d.bill_city || !d.bill_state || !d.bill_zip) {
      return showError('Please add your billing address (street, city, state and ZIP) so we can invoice your quotes.');
    }
    if (!EMAIL_RE.test(d.email)) {
      return showError('Please enter a valid email address.');
    }
    if (!endpoint || !window.fetch) {
      return showError('We couldn’t open a connection.' + FALLBACK);
    }

    var btn = form.querySelector('button[type=submit]');
    var btnLabel = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Submitting…'; }
    function restore() { if (btn) { btn.disabled = false; btn.textContent = btnLabel; } }

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(d)
    }).then(function (r) {
      return r.json().catch(function () { return { ok: false, error: 'bad response' }; });
    }).then(function (res) {
      if (!res || res.ok !== true) {
        restore();
        return showError('Something went wrong submitting your application.' + FALLBACK);
      }

      /* confirmed write — now (and only now) success + Klaviyo */
      var profile = {
        '$email': d.email,
        '$first_name': d.first,
        '$last_name': d.last,
        '$phone_number': d.phone,
        '$organization': d.company,
        'trade_status': 'pending',
        'trade_business_type': d.business_type,
        'trade_website': d.website,
        'trade_annual_orders': d.annual_orders,
        'trade_project_types': d.project_types,
        'trade_notes': d.message,
        'accepts_trade_marketing': true,
        'trade_source': 'trade-application-page'
      };
      klaviyoPush(['identify', profile]);
      klaviyoPush(['track', eventName, {
        company: d.company,
        business_type: d.business_type,
        annual_orders: d.annual_orders,
        project_types: d.project_types,
        website: d.website,
        marketing_consent: true,
        source: 'trade-application-page'
      }]);

      form.hidden = true;
      var aside = root.querySelector('.ktp2-apply__side');
      if (aside) aside.hidden = true;
      var body = root.querySelector('.ktp2-apply__body');
      if (body) body.style.gridTemplateColumns = '1fr';
      if (successEl) {
        successEl.hidden = false;
        try { successEl.setAttribute('tabindex', '-1'); successEl.focus(); } catch (err) {}
        try { successEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
      }
    }).catch(function () {
      restore();
      showError('We couldn’t reach the application service.' + FALLBACK);
    });
  });
})();

